import { StatusSignatureType } from "../../types/commonTypes/statusSignatureType";

export const statusSignatureWithoutPlaceInitialState: StatusSignatureType = {
    actNature: "acte sous seing privé",
    actDate: ""
}

export const statusSignatureWithPlaceInitialState: StatusSignatureType = {
    actNature: "acte sous seing privé",
    actDate: "",
    actPlace: ""
}